import { Grid } from "@mui/material";
import React from "react";
import { EnumHelper, RiskType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { DialogSectionCard } from "source/components/framework/Dialog/DialogSectionCard";
import { IRiskTemplateEditItem } from "ui/Scripts/source/models/riskTemplate/riskTemplateEditItem";
import { GridRow } from "source/components/framework/Grid/GridRow";
import { FormField } from "ui/Scripts/source/components/framework/FormField";
import { FormCheckBox } from "source/components/framework/FormCheckBox";
import { FormText } from "source/components/framework/FormText";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";

interface IRiskTemplateReviewProps {
    riskTemplate: IRiskTemplateEditItem;
    riskCategory: IIdTitleNode;
}

export const RiskTemplateReview = (props: IRiskTemplateReviewProps) => {
    if (!props.riskTemplate) return null;

    return <DialogSectionCard headerTitle={Translations.Preview}>
        <Grid sx={{
            overflowY: "auto",
            overflowX: "hidden",
            height: "100%",
            flexGrow: 1
        }}>
            <GridRow container>
                <Grid item sm={10}>
                    <FormField title={Translations.Name} fullWidth required margin="0">
                        <FormText
                            disabled={true}
                            tooltip={Translations.Name}
                            value={props.riskTemplate.code}
                            onChange={null}
                        />
                    </FormField>
                </Grid>
                <Grid item sm={2}>
                    <FormField fullWidth title={<span>&nbsp;</span>} margin="0">
                        <FormCheckBox
                            disabled={true}
                            title={Translations.InUse}
                            checked={props.riskTemplate.activeState > 0}
                            onChange={null}
                        />
                    </FormField>
                </Grid>
            </GridRow>
            <GridRow>
                <Grid item sm={3}>
                    <FormField title={Translations.AType}>
                        <FormText
                            disabled={true}
                            tooltip={Translations.AType}
                            value={props.riskTemplate.riskType === RiskType.Risk ? Translations.Risk : Translations.Opportunity}
                            onChange={null}
                        />
                    </FormField>
                </Grid>
                <Grid item sm={3}>
                    <FormField title={Translations.RiskCategory}>
                        <FormText
                            disabled={true}
                            tooltip={Translations.AType}
                            value={props.riskCategory?.title ?? ""}
                            onChange={null}
                        />
                    </FormField>
                </Grid>
                <Grid item sm={3}>
                    <FormField title={Translations.RiskOwner}>
                        <FormText
                            disabled={true}
                            tooltip={Translations.RiskOwner}
                            value={props.riskTemplate.owner}
                            onChange={null}
                        />
                    </FormField>
                </Grid>
                <Grid item sm={3}>
                    <FormField title={Translations.RiskAssesmentFrequency}>
                        <FormText
                            disabled={true}
                            tooltip={Translations.RiskAssesmentFrequency}
                            value={EnumHelper.RiskAssesmentFrequencyToStr(props.riskTemplate.assesmentFrequency)}
                            onChange={null}
                        />
                    </FormField>
                </Grid>
            </GridRow>
            <GridRow>
                <Grid item sm={12}>
                    <FormField title={Translations.Description} fullWidth>
                        <FormText
                            disabled={true}
                            tooltip={Translations.Description}
                            value={props.riskTemplate.description}
                            multiline
                            rows={6}
                            onChange={null}
                        />
                    </FormField>
                </Grid>
            </GridRow>
            <GridRow>
                <Grid item sm={6}>
                    <FormField title={Translations.RiskThreat} fullWidth>
                        <FormText
                            disabled={true}
                            tooltip={Translations.RiskThreat}
                            value={props.riskTemplate.threat}
                            multiline
                            rows={6}
                            onChange={null}
                        />
                    </FormField>
                </Grid>
                <Grid item sm={6}>
                    <FormField title={Translations.RiskControls} fullWidth>
                        <FormText
                            disabled={true}
                            tooltip={Translations.RiskControls}
                            value={props.riskTemplate.controls}
                            multiline
                            rows={6}
                            onChange={null}
                        />
                    </FormField>
                </Grid>
            </GridRow>
            {props.riskTemplate.opportunity &&
                <>
                    <Grid item sm={12}>
                        <FormField fullWidth title="">
                            <FormCheckBox
                                disabled={true}
                                title={Translations.Opportunity}
                                checked={true}
                                onChange={null}
                            />
                        </FormField>
                    </Grid>
                    <GridRow>
                        <Grid item sm={12}>
                            <FormField title={Translations.OpportunityBenefit} fullWidth>
                                <FormText
                                    disabled={true}
                                    tooltip={Translations.OpportunityBenefit}
                                    value={props.riskTemplate.opportunityBenefit}
                                    multiline
                                    rows={6}
                                    onChange={null}
                                />
                            </FormField>
                        </Grid>
                    </GridRow>
                    <GridRow>
                        <Grid item sm={12}>
                            <FormField title={Translations.OpportunityDescription} fullWidth>
                                <FormText
                                    disabled={true}
                                    tooltip={Translations.OpportunityDescription}
                                    value={props.riskTemplate.opportunityDescription}
                                    multiline
                                    rows={6}
                                    onChange={null}
                                />
                            </FormField>
                        </Grid>
                    </GridRow>
                </>
            }
        </Grid>
    </DialogSectionCard>;
};
